interface Endpoints {
    experimentsTree: () => string;
    clientSettings: () => string;
    deliveryDetails: () => string;
    activeBasketSummary: () => string;
    activeBasketPaymentMethods: () => string;
    completeBasket: () => string;
    paymentToken: () => string;
    customerEmail: (orderNumber: string) => string;
    updateOrder: (payPalOrderId: string) => string;
    getPayPalOrder: (payPalOrderId: string) => string;
    shippingMethods: (basketId: number, query?: URLSearchParams) => string;
    shippingMethod: () => string;
    braintreeToken: () => string;
    allocate: () => string;
    forterValidate: () => string;
    forterCancel: () => string;
    getUser: () => string;
}

const ENDPOINT: Endpoints = {
    experimentsTree: () => `api/experiments`,
    clientSettings: () => `api/client-settings`,
    deliveryDetails: () => 'api/basket/address',
    activeBasketSummary: () => 'api/basket/active/summary',
    activeBasketPaymentMethods: () => 'api/basket/active/payment/methods',
    completeBasket: () => 'api/basket/complete',
    paymentToken: () => 'api/payments/braintree/token',
    customerEmail: (orderNumber: string) => `api/orders/${orderNumber}/email`,
    updateOrder: (payPalOrderId: string) => `api/payments/paypal/${payPalOrderId}`,
    getPayPalOrder: (payPalOrderId: string) => `api/payments/paypal/${payPalOrderId}`,
    shippingMethod: () => 'api/basket/shipping-method',
    shippingMethods: (basketId, query) => {
        const url = `api/basket/${basketId}/shipping-methods`;
        return query ? `${url}?${query}` : url;
    },
    braintreeToken: () => `api/payments/braintree/token`,
    allocate: () => `api/basket/active/allocate`,
    forterValidate: () => 'api/basket/forter-validation',
    forterCancel: () => 'api/basket/forter-cancel',
    getUser: () => 'api/user',
};

export default ENDPOINT;
